import { useEffect, useState } from "react";

export default function Hero() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(true);
    }, 1500);
    return () => clearTimeout(timer);
  }, []);

  const scrollToProducts = () => {
    const productsSection = document.getElementById("products");
    if (productsSection) {
      productsSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center overflow-hidden pt-20"
    >
      {/* Background Image with Overlay */}
      <div className="absolute inset-0">
        <img
          src="https://static.readdy.ai/image/000f6613bbd5bf7f02c140851804a982/3a19b60d547595a8a0e7b9c9cb7458ad.jpeg"
          alt="Pharmaceutical Laboratory"
          className="w-full h-full object-cover animate-[zoomOut_6s_ease-out_forwards]"
        />
        {/* Dark Overlay */}
        <div className="absolute inset-0 bg-[#144E5D]/50"></div>
      </div>

      <div className="max-w-7xl mx-auto px-6 py-20 md:py-32 w-full relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">
          {/* Content Box with Frosted Glass Effect */}
          <div
            className={`flex-1 max-w-3xl transition-all duration-1000 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`}
          >
            <div className="bg-white/10 backdrop-blur-md rounded-2xl p-8 md:p-12 border border-white/20 shadow-2xl hover:shadow-3xl hover:scale-[1.02] transition-all duration-500 scale-[0.9] origin-left">
              {/* Headline */}
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold leading-tight mb-6 text-center lg:text-left">
                <span
                  className={`text-white block transition-all duration-700 delay-200 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}
                >
                  Quality Medicine,
                </span>
                <span
                  className={`text-white block transition-all duration-700 delay-400 ${isVisible ? "opacity-100 translate-x-0" : "opacity-0 -translate-x-10"}`}
                >
                  Made Affordable
                </span>
              </h1>

              {/* Supporting Text */}
              <p
                className={`text-lg md:text-xl text-white/90 leading-relaxed mb-10 text-center lg:text-left transition-all duration-700 delay-600 ${isVisible ? "opacity-100" : "opacity-0"}`}
              >
                Trusted pharmaceutical solutions for your everyday health needs.
                Products you can rely on.
              </p>

              {/* CTA Buttons */}
              <div
                className={`flex flex-wrap items-center justify-center lg:justify-start gap-4 transition-all duration-700 delay-800 ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-5"}`}
              >
                <button
                  onClick={scrollToProducts}
                  className="px-8 py-3.5 bg-white text-[#144E5D] font-semibold rounded-lg transition-all shadow-lg hover:shadow-xl hover:scale-105 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
                >
                  EXPLORE PRODUCTS
                </button>
                <button
                  onClick={() =>
                    document
                      .getElementById("about")
                      ?.scrollIntoView({ behavior: "smooth" })
                  }
                  className="px-8 py-3.5 border-2 border-white text-white hover:bg-white/10 font-semibold rounded-lg transition-all hover:scale-105 hover:-translate-y-1 cursor-pointer whitespace-nowrap"
                >
                  LEARN MORE
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
